import { Component, Input } from '@angular/core';
import { Sid } from '../../../audit/sid.model';
import {DISPLAY_DATE_FORMAT} from '../../../app.constants';

@Component({
  selector: 'iaud-sid-title',
  templateUrl: './sid-title.component.html',
  styleUrls: ['./sid-title.component.scss']
})
export class SidTitleComponent {

  @Input()
  sid: Sid;

  dateFormat: string = DISPLAY_DATE_FORMAT;
}
